import httpClient from '@/http-client'

export const get = (options = {}) => {
  return httpClient
    .get('/api/student-galleries', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/student-galleries', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const destroy = id => {
  return httpClient
    .delete(`/api/student-galleries/${id}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const download = id => {
  return httpClient
    .get(`/api/student-galleries/downloads/${id}`, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response.data))
    .catch(response => Promise.reject(response.data))
}
export const removePhoto = id => {
  return httpClient
    .get(`/api/student-galleries/remove-photos/${id}`)
    .then(response => Promise.resolve(response.data))
    .catch(response => Promise.reject(response.data))
}
export const removeFile = (Options = {}) => {
  return httpClient
    .get('/api/student-galleries/remove-files', Options)
    .then(response => Promise.resolve(response.data))
    .catch(response => Promise.reject(response.data))
}
export default {
  get,
  store,
  destroy,
  download,
  removePhoto,
  removeFile
}
